import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {NotifactionService} from '../services/notification.service';
import {environment} from '../../../environments/environment';
import {CoreService} from '../services/core.service';


export const globalHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notification = inject(NotifactionService);
  const coreService = inject(CoreService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // The bootstrap APP_INITIALIZER chain calls fetchProfile() before the
      // app config has necessarily rendered a decision -- an unauthenticated
      // visitor 401s there every time, which would otherwise hard-redirect
      // past the maintenance gate (app.html) before it ever gets to render.
      if (error.status === 401 && !coreService.appConfig()?.maintenance?.partner) {
        const currentUrl = encodeURIComponent(window.location.href);
        window.location.href = `${environment.authUrl}/login?redirect=${currentUrl}`;
      }
      if (error.status === 0) {
        notification.error('NETWORK_ERROR', error.message, error.status.toString());
      }

      if (error.status >= 500) {
        notification.error('Error', error.message, error.status.toString());
      }

      if (error.status === 400 || error.status === 422) {
        const message = error.error?.message || 'Request failed';
        notification.error('Error', message, error.status.toString());
      }

      return throwError(() => error);
    }),
  );
};
